import React from 'react';
import './contentSkeleton.css';

// Read-only shapes shared by Academy and Staff training. No sample personal data.
export default function ContentSkeleton({label, rows=3, variant='list', compact=false}) {
  const shape = compact ? 'refresh' : variant;
  const bar = (className='') => <span className={`content-skeleton-bar ${className}`}/>;
  return <div role="status" aria-busy="true" data-loading-shape={shape} className={`content-skeleton content-skeleton-${shape}`}>
    <span className="sr-only">{label}</span>
    <div aria-hidden="true" className="content-skeleton-shapes">
      {shape==='refresh' ? bar('is-refresh') : <>
        {shape!=='rows' && <header>{bar('is-title')}{bar('is-meta')}</header>}
        {['register','report','detail','assignment','result'].includes(shape) && <div className="content-skeleton-summary">{[0,1,2].map(i=><div key={i}>{bar('is-meta')}{bar('is-value')}</div>)}</div>}
        {shape==='assignment' && <div className="content-skeleton-steps">{[0,1,2].map(i=><div key={i}>{bar('is-meta')}</div>)}</div>}
        <div className="content-skeleton-rows">{Array.from({length:rows},(_,i)=><div className="content-skeleton-row" key={i}>{bar('is-row-title')}{bar('is-meta')}{['register','assignment','result'].includes(shape)&&bar('is-action')}</div>)}</div>
        {shape!=='rows' && bar('is-action')}
      </>}
    </div>
  </div>;
}
